import { PaymentLogoPill } from "@/components/PaymentLogoPill";
import { useSEO } from "@/hooks/use-seo";
import {
  ReviewTableOfContents, StickyReviewHeader, ProsConsHeroBlock,
  ResponsibleGamingChecklist, AuthorBylineCard, UpdateDateLine,
} from "@/components/CasinoReviewTemplate";
import mykhailoPhoto from "@assets/image_1773345523383.png";
import { useState } from "react";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import {
  ArrowRight, Star, CheckCircle, XCircle, ShieldCheck, Gamepad2,
  HeadphonesIcon, Info, Heart, CreditCard, Clock, Mail, MessageCircle,
  Phone, Calendar, Lock, Users, Trophy, Zap, AlertTriangle, Globe, Swords
} from "lucide-react";
import { Button } from "@/components/ui/button";
import logo16 from "@assets/logos_extracted/16.png";
import { CasinoBreadcrumb } from "@/components/CasinoBreadcrumb";
import { DalsiRecenze } from "@/components/DalsiRecenze";

const CASINO_URL = "https://wzbw.monvaki.com/?mid=282906_1667059";

const tabs = [
  { id: "platby",     label: "Platby",              icon: CreditCard },
  { id: "hry",        label: "Hry",                 icon: Gamepad2 },
  { id: "podpora",    label: "Zákaznická podpora",  icon: HeadphonesIcon },
  { id: "obecne",     label: "Obecné informace",    icon: Info },
  { id: "zodpovedne", label: "Zodpovědné hraní",    icon: Heart },
];

const pros = [
  "Zábavné gamifikované kasino s barevným džunglí designem, avatary a herními misemi",
  "Obrovská knihovna her (5 000+ her) a sekce živého kasina",
  "Štědrý uvítací bonus a sport bonus pro sázkaře",
  "Podporuje kryptoměny i mnoho měn včetně Kč",
  "Rychlé výplaty – e-peněženky a krypto obvykle do 24 hodin",
  "Nonstop podpora 24/7",
];

const cons = [
  "Kasino nemá mobilní aplikaci – jen responzivní web",
  "Podmínky bonusu jsou přísné (wager 35×)",
  "Vklady přes Neteller nebo Skrill neplatí pro uvítací bonus",
  "Mnoho zemí je omezeno",
  "Provoz pouze pod licencí Anjouan (ne česká regulace)",
];

function TabContent({ activeTab }: { activeTab: string }) {
  const rowClass = "flex flex-col sm:flex-row sm:items-start gap-1 py-3 border-b border-[#eef1f7] last:border-0";
  const labelClass = "text-gray-500 text-sm sm:w-48 flex-shrink-0";
  const valueClass = "text-gray-900 text-sm font-medium leading-relaxed";

  if (activeTab === "platby") {
    return (
      <div className="divide-y divide-[#eef1f7]">
        <div className={rowClass}><span className={labelClass}>Minimální vklad:</span><span className={valueClass}>250 Kč (500 Kč pro uvítací bonus)</span></div>
        <div className={rowClass}><span className={labelClass}>Minimální výběr:</span><span className={valueClass}>250 Kč</span></div>
        <div className={rowClass}><span className={labelClass}>E-peněženky / krypto:</span><span className={valueClass}>Obvykle 0–24 hodin</span></div>
        <div className={rowClass}><span className={labelClass}>Karty / bankovní převod:</span><span className={valueClass}>Přibližně 3–5 pracovních dní</span></div>
        <div className={rowClass}>
          <span className={labelClass}>Metody vkladu:</span>
          <div className="flex flex-wrap gap-1.5">{["Visa", "Mastercard", "Bankovní převod", "Paysafecard", "Skrill", "Neteller", "Jeton", "MiFinity", "Siru Mobile", "Rapid Transfer", "Neosurf", "Interac", "Bitcoin", "Ethereum", "Litecoin", "Tether"].map(m => <PaymentLogoPill key={m} name={m} />)}</div>
        </div>
        <div className={rowClass}>
          <span className={labelClass}>Metody výběru:</span>
          <div className="flex flex-wrap gap-1.5">{["Visa", "Mastercard", "Bankovní převod", "Skrill", "Neteller", "Jeton", "MiFinity", "MuchBetter", "Rapid Transfer", "Interac", "Bitcoin", "Ethereum", "Litecoin", "Tether", "USD Coin", "Ripple"].map(m => <PaymentLogoPill key={m} name={m} />)}</div>
        </div>
        <div className={rowClass}><span className={labelClass}>Pozor u bonusu:</span><span className={valueClass}>Vklady přes Neteller nebo Skrill se nepočítají pro uvítací bonus</span></div>
      </div>
    );
  }
  if (activeTab === "hry") {
    return (
      <div className="divide-y divide-[#eef1f7]">
        <div className={rowClass}><span className={labelClass}>Celkový počet her:</span><span className={valueClass}>5 000+</span></div>
        <div className={rowClass}><span className={labelClass}>Hrací automaty:</span><span className={valueClass}>2 000+ titulů</span></div>
        <div className={rowClass}><span className={labelClass}>Ruleta:</span><span className={valueClass}>Evropská, americká + živá ruleta (~20 stolů)</span></div>
        <div className={rowClass}><span className={labelClass}>Blackjack:</span><span className={valueClass}>Více variant + živý blackjack (~20 stolů)</span></div>
        <div className={rowClass}><span className={labelClass}>Sportovní sázení:</span><span className={valueClass}>Ano – plnohodnotná sázková sekce</span></div>
        <div className={rowClass}><span className={labelClass}>Klíčoví poskytovatelé:</span><span className={valueClass}>NetEnt, Play'n GO, Pragmatic Play, Evolution Gaming, Novomatic, Yggdrasil, Playtech, Quickspin, Betsoft, Microgaming, Nolimit City a další</span></div>
      </div>
    );
  }
  if (activeTab === "podpora") {
    return (
      <div className="divide-y divide-[#eef1f7]">
        <div className={rowClass}><span className={labelClass}>Dostupnost:</span><span className={valueClass}>24/7</span></div>
        <div className={rowClass}><span className={labelClass}>Live chat:</span><span className={valueClass}>Ano – na webu</span></div>
        <div className={rowClass}><span className={labelClass}>E-mail:</span><span className={valueClass}>support@wazamba.com</span></div>
        <div className={rowClass}><span className={labelClass}>Telefon:</span><span className={valueClass}>Ano</span></div>
        <div className={rowClass}><span className={labelClass}>Čeština:</span><span className={valueClass}>Dostupná (automatický překlad v chatu)</span></div>
        <div className={rowClass}><span className={labelClass}>Jazyky webu:</span><span className={valueClass}>CS, DE, EN, FR, IT, PL, PT, HU, NO, SK, SL, FI a 15 dalších</span></div>
      </div>
    );
  }
  if (activeTab === "obecne") {
    return (
      <div className="divide-y divide-[#eef1f7]">
        <div className={rowClass}><span className={labelClass}>Rok spuštění:</span><span className={valueClass}>2019</span></div>
        <div className={rowClass}><span className={labelClass}>Provozovatel:</span><span className={valueClass}>Rabidi N.V.</span></div>
        <div className={rowClass}><span className={labelClass}>Licence:</span><span className={valueClass}>Anjouan</span></div>
        <div className={rowClass}><span className={labelClass}>Platformy:</span><span className={valueClass}>PC, mobilní prohlížeč (bez aplikace)</span></div>
        <div className={rowClass}><span className={labelClass}>Čeština:</span><span className={valueClass}>Ano</span></div>
        <div className={rowClass}><span className={labelClass}>CZK (Kč):</span><span className={valueClass}>Ano</span></div>
        <div className={rowClass}><span className={labelClass}>Kryptoměny:</span><span className={valueClass}>BTC, ETH, LTC, USDT, XRP a další</span></div>
        <div className={rowClass}><span className={labelClass}>Přijímané měny:</span><span className={valueClass}>Kč, EUR, USD, CAD, AUD, PLN, HUF, NOK, INR, BRL, JPY a další</span></div>
        <div className={rowClass}><span className={labelClass}>Sportovní sázení:</span><span className={valueClass}>Ano</span></div>
        <div className={rowClass}><span className={labelClass}>Česká republika:</span><span className={valueClass}>Přístup povolen</span></div>
      </div>
    );
  }
  if (activeTab === "zodpovedne") {
    const items: [string, string][] = [
      ["Deposit limity:", "Nastavitelné v profilu"],
      ["Sebevyloučení:", "Ano"],
      ["Věková hranice:", "18+"],
      ["Licence:", "Anjouan (ne česká regulace MF ČR)"],
    ];
    return <ResponsibleGamingChecklist items={items} />;
  }
  return null;
}

export default function WazambaPage() {
  useSEO({ title: "Wazamba Casino Recenze 2026 – Gamifikace, bonus a free spiny | HrajBonus", description: "Recenze Wazamba Casino. Unikátní africké téma, gamifikace, věrnostní program a velký výběr her. Uvítací bonus + free spiny. 18+",
  url: "https://hrajbonus.com/kasina/wazamba", });

  const [activeTab, setActiveTab] = useState("platby");

  return (
    <>
      <StickyReviewHeader casinoName="Wazamba Casino" logoSrc={logo16} rating="9.0" ctaUrl={CASINO_URL} />
      <Header />
      <main className="bg-[#f7f9fd] min-h-screen pt-[64px]">

        {/* ── Hero ─────────────────────────────────────────── */}
        <div style={{ background: "linear-gradient(135deg, #001a4d 0%, #002d7c 50%, #003da5 100%)" }}>
          <div className="max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-12 xl:px-16 py-10 sm:py-14">
            <div className="flex flex-col lg:flex-row lg:items-center gap-8 lg:gap-12">

              <div className="flex-1">
                <div className="flex items-center gap-6 mb-5">
                  <div className="w-[100px] h-[100px] rounded-xl flex-shrink-0 overflow-hidden shadow-lg">
                    <img src={logo16} alt="Wazamba Casino logo" className="w-full h-full object-cover" />
                  </div>
                  <div>
                    <div className="text-white/60 text-sm font-medium mb-0.5">Recenze kasina</div>
                    <h1 className="text-white font-bold text-2xl sm:text-3xl leading-tight">Recenze Kasina Wazamba</h1>
                    <UpdateDateLine date="15/02/2026" authorName="Mykhailo Romaenko" />
                  </div>
                </div>

                <div className="flex items-center gap-2 mb-5">
                  <div className="flex gap-0.5">
                    {[1,2,3,4].map(i => (
                      <Star key={i} className="w-5 h-5 fill-[#f5c518] text-[#f5c518]" />
                    ))}
                    <div className="relative w-5 h-5">
                      <Star className="w-5 h-5 text-[#f5c518]/30 absolute inset-0" />
                      <div className="overflow-hidden absolute inset-0" style={{ width: "50%" }}>
                        <Star className="w-5 h-5 fill-[#f5c518] text-[#f5c518]" />
                      </div>
                    </div>
                  </div>
                  <span className="text-white font-bold text-xl">9.0</span>
                  <span className="text-white/50 text-sm">/10</span>
                </div>

                <div className="grid grid-cols-2 sm:grid-cols-4 gap-3">
                  {[
                    { label: "Počet her",       value: "5 000+" },
                    { label: "Hrací automaty",  value: "2 000+" },
                    { label: "Minimální vklad", value: "250 Kč" },
                    { label: "Výplaty e-wallet", value: "0–24 hod" },
                  ].map(s => (
                    <div key={s.label} className="bg-white/10 rounded-lg px-3 py-2.5 backdrop-blur-sm">
                      <div className="text-white/55 text-xs mb-0.5">{s.label}</div>
                      <div className="text-white font-bold text-sm">{s.value}</div>
                    </div>
                  ))}
                </div>

                <div className="flex flex-wrap gap-2 mt-4">
                  <span className="bg-white/15 text-white/90 text-xs font-semibold px-3 py-1 rounded-full">Gamifikace &amp; Avatary</span>
                  <span className="bg-white/15 text-white/90 text-xs font-semibold px-3 py-1 rounded-full">Non-sticky bonus</span>
                  <span className="bg-white/15 text-white/90 text-xs font-semibold px-3 py-1 rounded-full">Kasino + Sázková kancelář</span>
                  <span className="bg-white/15 text-white/90 text-xs font-semibold px-3 py-1 rounded-full">Čeština + Kč</span>
                </div>

                <div className="mt-3 text-white/50 text-xs font-medium">
                  Česká republika má přístup povolen · Přijímá Kč
                </div>

                <ProsConsHeroBlock pros={pros} cons={cons} />
              </div>

              <div className="lg:w-[320px] bg-white/10 border border-white/20 rounded-2xl p-6 backdrop-blur-sm">
                <div className="text-center mb-4">
                  <div className="text-white/70 text-sm mb-1">Uvítací bonus (non-sticky)</div>
                  <div className="text-white font-black text-2xl leading-tight">až 12 500 Kč</div>
                  <div className="text-[#f5c518] font-bold text-lg">+ 200 free spinů</div>
                  <div className="text-white/50 text-xs mt-1">Wager 35× · Min. vklad 500 Kč</div>
                </div>
                <a href={CASINO_URL} target="_blank" rel="sponsored noopener noreferrer" className="block">
                  <Button
                    className="hraj-btn w-full font-bold text-base py-3 gap-2"
                    data-testid="button-hero-cta"
                  >
                    Hraj <ArrowRight className="hraj-arrow w-4 h-4" />
                  </Button>
                </a>
                <p className="text-white/40 text-xs text-center mt-3 leading-relaxed">
                  18+ | Zodpovědné hraní | Platí podmínky
                </p>
              </div>
            </div>
          </div>
        </div>

                <CasinoBreadcrumb casinoName="Wazamba" />

<div className="max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-12 xl:px-16 py-8 sm:py-12">
          <div className="flex flex-col lg:flex-row gap-8 lg:gap-10">

            <div className="flex-1 min-w-0 space-y-8">

              <ReviewTableOfContents />

              {/* Author opinion */}
              <AuthorBylineCard name="Mykhailo Romaenko" initials="MR" photo={mykhailoPhoto} role="Senior Content Writer" score="9.0" date="15/02/2026">
                <h2 className="font-bold text-gray-900 text-base mb-2">Recenze Kasina Wazamba</h2>
                <p className="text-gray-600 text-sm leading-relaxed">
                  Wazamba nabízí zábavné gamifikované kasino s barevným designem, Bonus Crabem a tisíci her. Podporuje mnoho jazyků a měn, včetně krypta. Štědrý uvítací bonus, nonstop podpora a herní mise osloví rekreační hráče. Kasino je provozováno skupinou Rabidi N.V. a funguje od roku 2019.
                </p>

                <div className="grid sm:grid-cols-2 gap-4 mt-5">
                  <div>
                    <div className="flex items-center gap-1.5 font-bold text-green-700 text-xs uppercase tracking-wide mb-2">
                      <CheckCircle className="w-3.5 h-3.5" /> Výhody
                    </div>
                    <ul className="space-y-1.5">
                      {pros.map(p => (
                        <li key={p} className="flex items-start gap-1.5 text-gray-700 text-sm">
                          <span className="text-green-500 font-bold mt-0.5 flex-shrink-0">+</span> {p}
                        </li>
                      ))}
                    </ul>
                  </div>
                  <div>
                    <div className="flex items-center gap-1.5 font-bold text-red-600 text-xs uppercase tracking-wide mb-2">
                      <XCircle className="w-3.5 h-3.5" /> Nevýhody
                    </div>
                    <ul className="space-y-1.5">
                      {cons.map(c => (
                        <li key={c} className="flex items-start gap-1.5 text-gray-700 text-sm">
                          <span className="text-gray-400 font-bold mt-0.5 flex-shrink-0">▬</span> {c}
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </AuthorBylineCard>

              {/* Tabs */}
              <div className="bg-white rounded-2xl border border-[#dde4ee] shadow-sm overflow-hidden" data-testid="casino-overview-tabs">
                <div className="px-5 pt-5 pb-0 border-b border-[#eef1f7]">
                  <h2 className="font-bold text-gray-900 text-base mb-4">Přehled kasina</h2>
                  <div className="flex gap-0 overflow-x-auto -mx-5 px-5">
                    {tabs.map(tab => (
                      <button
                        key={tab.id}
                        onClick={() => setActiveTab(tab.id)}
                        className={`flex items-center gap-1.5 px-3 py-2.5 text-xs font-semibold whitespace-nowrap border-b-2 transition-colors flex-shrink-0 ${
                          activeTab === tab.id
                            ? "border-[#003da5] text-[#003da5]"
                            : "border-transparent text-gray-500 hover:text-gray-700"
                        }`}
                        data-testid={`tab-${tab.id}`}
                      >
                        <tab.icon className="w-3.5 h-3.5" />
                        {tab.label}
                      </button>
                    ))}
                  </div>
                </div>
                <div className="p-5">
                  <TabContent activeTab={activeTab} />
                </div>
              </div>

              {/* About & Gamification */}
              <div id="prehled" className="bg-white rounded-2xl border border-[#dde4ee] p-6 shadow-sm">
                <h2 className="font-black text-gray-900 text-xl sm:text-2xl mb-4">Gamifikované kasino s džunglí a herními misemi</h2>
                <p className="text-gray-600 leading-relaxed mb-4">
                  Wazamba se odlišuje od ostatních kasin jedinečným designem inspirovaným džunglí a propracovanou gamifikací. Hráči si vytvářejí vlastní avatary, plní herní mise a sbírají úspěchy. Platforma kombinuje online kasino s plnohodnotnou sázkovou kanceláří.
                </p>
                <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-3 mb-5">
                  {[
                    { icon: Trophy,  label: "Avatary a úspěchy",  desc: "Vytvořte svého avatara a sbírejte úspěchy za splněné mise" },
                    { icon: Swords,  label: "Herní mise",          desc: "Unikátní gamifikační prvky pro rekreační i zkušené hráče" },
                    { icon: Zap,     label: "Bonus Crab",          desc: "Originální promo mechanika s mini-herními odměnami" },
                    { icon: Gamepad2, label: "5 000+ her",         desc: "Automaty, live kasino, stolní hry, sportovní sázení" },
                    { icon: Globe,   label: "Čeština + Kč",        desc: "Web i podpora dostupné v češtině; přijímá koruny" },
                    { icon: Lock,    label: "Kryptoměny",          desc: "BTC, ETH, LTC, USDT, XRP a další bez vysokých poplatků" },
                  ].map(({ icon: Icon, label, desc }) => (
                    <div key={label} className="bg-[#f3f6fb] rounded-xl p-3">
                      <div className="flex items-center gap-1.5 mb-1">
                        <Icon className="w-3.5 h-3.5 text-[#003da5]" />
                        <span className="font-semibold text-gray-900 text-xs">{label}</span>
                      </div>
                      <div className="text-gray-600 text-xs leading-relaxed">{desc}</div>
                    </div>
                  ))}
                </div>

                <div className="bg-amber-50 border border-amber-300 rounded-xl p-4 flex gap-3">
                  <AlertTriangle className="w-5 h-5 text-amber-600 mt-0.5 flex-shrink-0" />
                  <p className="text-amber-700 text-sm leading-relaxed">
                    Wazamba provozuje svou činnost na základě licence Anjouan. Nejde o licenci vydanou Ministerstvem financí ČR – právní ochrana pro české hráče se proto liší od lokálně regulovaných operátorů.
                  </p>
                </div>
              </div>

              {/* Games */}
              <div id="hry" className="bg-white rounded-2xl border border-[#dde4ee] p-6 shadow-sm">
                <h2 className="font-bold text-gray-900 text-lg sm:text-xl mb-4">Hry &amp; Poskytovatelé</h2>
                <div className="grid sm:grid-cols-2 gap-3 mb-4">
                  {[
                    ["Hrací automaty",    "2 000+ titulů – klasické, video sloty, jackpoty"],
                    ["Ruleta",            "Evropská, americká + živá ruleta s ~20 stoly"],
                    ["Blackjack",         "Více variant + živý blackjack s ~20 stoly"],
                    ["Sportovní sázení",  "Plnohodnotná sázková sekce s vlastním bonusem"],
                  ].map(([label, val]) => (
                    <div key={label} className="bg-[#f3f6fb] rounded-xl p-3">
                      <div className="font-semibold text-gray-900 text-xs mb-0.5">{label}</div>
                      <div className="text-gray-600 text-xs">{val}</div>
                    </div>
                  ))}
                </div>
                <div className="bg-[#f0f5ff] border border-[#003da5]/15 rounded-xl p-4">
                  <div className="font-bold text-[#003da5] text-xs mb-2">Klíčoví poskytovatelé</div>
                  <div className="flex flex-wrap gap-1.5">
                    {["NetEnt", "Play'n GO", "Pragmatic Play", "Evolution Gaming", "Novomatic", "Yggdrasil", "Playtech", "Quickspin", "Betsoft", "Microgaming", "Nolimit City"].map(p => (
                      <span key={p} className="bg-white border border-[#003da5]/15 text-gray-700 text-xs px-2.5 py-1 rounded-full font-medium">{p}</span>
                    ))}
                    <span className="text-gray-400 text-xs self-center">a další...</span>
                  </div>
                </div>
              </div>

              {/* Bonuses */}
              <div id="bonusy" className="bg-white rounded-2xl border border-[#dde4ee] p-6 shadow-sm">
                <h2 className="font-bold text-gray-900 text-lg sm:text-xl mb-4">Bonusy &amp; Akce</h2>
                <p className="text-gray-600 leading-relaxed mb-5">
                  Wazamba nabízí uvítací balíček ve formě <strong>non-sticky (nelepivého) bonusu</strong> jak pro kasinové hráče, tak pro sportovní sázkaře. Reálné výhry jsou odděleny od bonusových prostředků.
                </p>

                <div className="grid sm:grid-cols-2 gap-4 mb-5">
                  <div className="bg-[#f0f5ff] border border-[#003da5]/20 rounded-xl p-4">
                    <div className="text-[#003da5] font-black text-lg mb-0.5">Casino bonus</div>
                    <div className="text-gray-900 font-bold text-base mb-1">100% až 12 500 Kč</div>
                    <div className="text-[#c9960f] font-bold text-sm mb-2">+ 200 free spinů</div>
                    <div className="text-gray-500 text-xs space-y-0.5">
                      <div>Non-sticky · Wager 35× (vklad+bonus)</div>
                      <div>Min. vklad: 500 Kč</div>
                    </div>
                  </div>
                  <div className="bg-[#f3f6fb] border border-[#dde4ee] rounded-xl p-4">
                    <div className="text-gray-700 font-bold text-lg mb-0.5">Sport bonus</div>
                    <div className="text-gray-900 font-bold text-base mb-1">100% až 2 500 Kč</div>
                    <div className="text-gray-500 text-sm mb-2">Na první vklad do sázkové sekce</div>
                    <div className="text-gray-500 text-xs space-y-0.5">
                      <div>Min. vklad: 500 Kč</div>
                      <div>Nutné jednou prosázet na kurz ≥ 1,50</div>
                    </div>
                  </div>
                </div>

                <div className="bg-amber-50 border border-amber-200 rounded-xl p-4 mb-4">
                  <div className="flex items-start gap-2">
                    <AlertTriangle className="w-4 h-4 text-amber-600 mt-0.5 flex-shrink-0" />
                    <p className="text-amber-700 text-sm leading-relaxed">
                      <strong>Pozor:</strong> Vklady provedené přes Neteller nebo Skrill se nepočítají pro aktivaci uvítacího bonusu. Pokud chcete bonus využít, zvolte jinou metodu vkladu (karta, bankovní převod, krypto, Paysafecard apod.).
                    </p>
                  </div>
                </div>

                <div className="bg-green-50 border border-green-200 rounded-xl p-4">
                  <div className="font-bold text-green-800 text-sm mb-1.5">Co je non-sticky bonus?</div>
                  <p className="text-green-700 text-sm leading-relaxed">
                    U nelepivých bonusů jsou reálné výhry odděleny od bonusových prostředků. Pokud vyhrajete ze svého vlastního vkladu ještě před splněním wageru, tyto reálné výhry lze vybrat. Jde o výrazně hráč-přívětivější podmínky než u klasického sticky bonusu.
                  </p>
                </div>
              </div>

              {/* Payments */}
              <div id="platby-sekce" className="bg-white rounded-2xl border border-[#dde4ee] p-6 shadow-sm">
                <h2 className="font-bold text-gray-900 text-lg sm:text-xl mb-4">Platební metody</h2>
                <div className="grid grid-cols-2 sm:grid-cols-3 gap-3 mb-5">
                  {[
                    { label: "Min. vklad (obecný)",  value: "250 Kč" },
                    { label: "Min. vklad (bonus)",   value: "500 Kč" },
                    { label: "Min. výběr",           value: "250 Kč" },
                    { label: "E-peněženky / krypto", value: "0–24 hodin" },
                    { label: "Karty / bank. převod", value: "3–5 prac. dní" },
                    { label: "Neteller/Skrill",      value: "Nezapočítávají do bonusu" },
                  ].map(({ label, value }) => (
                    <div key={label} className={`rounded-xl p-3 ${label === "Neteller/Skrill" ? "bg-amber-50 border border-amber-200" : "bg-[#f3f6fb]"}`}>
                      <div className="text-gray-500 text-xs mb-0.5">{label}</div>
                      <div className={`font-bold text-xs ${label === "Neteller/Skrill" ? "text-amber-700" : "text-gray-900"}`}>{value}</div>
                    </div>
                  ))}
                </div>

                <div className="grid sm:grid-cols-2 gap-4">
                  <div className="bg-[#f3f6fb] rounded-xl p-4">
                    <div className="font-bold text-gray-900 text-sm mb-2">Metody vkladu</div>
                    <div className="flex flex-wrap gap-1">
                      {["Visa", "Mastercard", "Paysafecard", "Skrill", "Neteller", "Jeton", "MiFinity", "Neosurf", "Interac", "Bitcoin", "Ethereum", "Tether"].map(m => (
                        <PaymentLogoPill key={m} name={m} />
                      ))}
                    </div>
                  </div>
                  <div className="bg-[#f3f6fb] rounded-xl p-4">
                    <div className="font-bold text-gray-900 text-sm mb-2">Metody výběru</div>
                    <div className="flex flex-wrap gap-1">
                      {["Visa", "Mastercard", "Skrill", "Neteller", "Jeton", "MiFinity", "MuchBetter", "Interac", "Bitcoin", "Ethereum", "Litecoin", "Ripple"].map(m => (
                        <PaymentLogoPill key={m} name={m} />
                      ))}
                    </div>
                  </div>
                </div>
              </div>

              {/* Support */}
              <div id="podpora-sekce" className="bg-white rounded-2xl border border-[#dde4ee] p-6 shadow-sm">
                <h2 className="font-bold text-gray-900 text-lg sm:text-xl mb-4">Zákaznická podpora</h2>
                <p className="text-gray-600 leading-relaxed mb-4">
                  Zákaznická podpora je dostupná 24/7. Podpora komunikuje anglicky i v dalších jazycích – pro češtinu a jiné využívá automatický překlad v live chatu.
                </p>
                <div className="grid sm:grid-cols-3 gap-3">
                  <div className="flex items-start gap-3 p-3 bg-green-50 border border-green-100 rounded-xl">
                    <MessageCircle className="w-5 h-5 text-green-600 mt-0.5 flex-shrink-0" />
                    <div>
                      <div className="font-semibold text-gray-900 text-sm">Live chat</div>
                      <div className="text-green-600 text-xs">24/7</div>
                    </div>
                  </div>
                  <div className="flex items-start gap-3 p-3 bg-green-50 border border-green-100 rounded-xl">
                    <Mail className="w-5 h-5 text-green-600 mt-0.5 flex-shrink-0" />
                    <div>
                      <div className="font-semibold text-gray-900 text-sm">E-mail</div>
                      <div className="text-green-600 text-xs">support@wazamba.com</div>
                    </div>
                  </div>
                  <div className="flex items-start gap-3 p-3 bg-green-50 border border-green-100 rounded-xl">
                    <Phone className="w-5 h-5 text-green-600 mt-0.5 flex-shrink-0" />
                    <div>
                      <div className="font-semibold text-gray-900 text-sm">Telefon</div>
                      <div className="text-green-600 text-xs">Dostupný</div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Mobile */}
              <div id="mobilni" className="bg-white rounded-2xl border border-[#dde4ee] p-6 shadow-sm">
                <h2 className="font-bold text-gray-900 text-lg sm:text-xl mb-4">Mobilní hraní</h2>
                <p className="text-gray-600 leading-relaxed mb-4">
                  Wazamba nemá vlastní mobilní aplikaci, ale web je plně optimalizovaný pro mobilní zařízení. Stačí otevřít prohlížeč na smartphonu nebo tabletu a všechny hry, bonusy i sázkový oddíl fungují bez omezení. Responzivní design zajišťuje pohodlné ovládání na jakékoliv obrazovce.
                </p>
                <div className="grid sm:grid-cols-2 gap-2">
                  {[
                    ["Mobilní web", "Plně optimalizovaný, bez stahování"],
                    ["iOS & Android", "Kompatibilní se všemi zařízeními"],
                    ["Live kasino", "Dostupné i na mobilu"],
                    ["Sportovní sázky", "Plná funkčnost na mobilu"],
                  ].map(([label, value]) => (
                    <div key={label} className="flex items-start gap-2 bg-[#f3f6fb] rounded-xl p-3">
                      <CheckCircle className="w-4 h-4 text-green-600 mt-0.5 flex-shrink-0" />
                      <div>
                        <div className="text-gray-900 text-xs font-semibold">{label}</div>
                        <div className="text-gray-500 text-xs">{value}</div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              {/* Responsible gaming */}
              <div id="zodpovedne-sekce" className="bg-white rounded-2xl border border-[#dde4ee] p-6 shadow-sm">
                <h2 className="font-bold text-gray-900 text-lg sm:text-xl mb-4">Zodpovědné hraní</h2>
                <p className="text-gray-600 leading-relaxed mb-4">
                  Hazardní hry jsou určeny pro zábavu. Vždy zůstaňte ve svých mezích a sázejte jen tolik, kolik si můžete dovolit prohrát.
                </p>
                <div className="grid sm:grid-cols-3 gap-2">
                  {[
                    "Nastavení vkladových limitů",
                    "Dočasné a trvalé sebevyloučení",
                    "Věková hranice 18+",
                  ].map(item => (
                    <div key={item} className="flex items-start gap-2 bg-[#f3f6fb] rounded-xl p-3">
                      <ShieldCheck className="w-4 h-4 text-[#003da5] mt-0.5 flex-shrink-0" />
                      <span className="text-gray-700 text-xs leading-relaxed">{item}</span>
                    </div>
                  ))}
                </div>
              </div>

              {/* Verdict */}
              <div id="verdikt" className="bg-white rounded-2xl border border-[#dde4ee] p-6 shadow-sm">
                <h2 className="font-bold text-gray-900 text-lg sm:text-xl mb-4">Verdikt</h2>
                <p className="text-gray-600 leading-relaxed">
                  Wazamba je zábavné gamifikované kasino, které se hodí především pro rekreační hráče hledající pestrý herní zážitek. Silnou stránkou je non-sticky bonus, široký výběr her a podpora kryptoměn. Kdo hledá tradiční, střízlivé kasino bez gamifikace, najde lepší volby jinde, ale pro ty, kdo chtějí něco navíc, je Wazamba solidní volba.
                </p>
              </div>

              {/* Author bio */}
              <div className="bg-white rounded-2xl border border-[#dde4ee] p-6 shadow-sm" data-testid="author-bio">
                <div className="flex items-center gap-4 mb-4">
                  <div className="w-14 h-14 rounded-full bg-[#003da5] flex items-center justify-center flex-shrink-0">
                    <span className="text-white font-bold text-lg">MR</span>
                  </div>
                  <div>
                    <div className="font-bold text-gray-900">Mykhailo Romaenko</div>
                    <div className="text-[#003da5] text-sm font-medium">Senior Content Writer</div>
                  </div>
                </div>
                <p className="text-gray-600 text-sm leading-relaxed">
                  Mykhailo je zkušený autor zaměřený na iGaming, který se dlouhodobě pohybuje v odvětví online hazardu. Má bohatou praxi v psaní článků, které propojují svět hráčů i profesionálů. Jeho specialitou je vytváření hlubokých analýz, přehledných recenzí a trendově orientovaného obsahu, který čtenářům přináší nejen zábavu, ale i znalosti.
                </p>
                <p className="text-gray-600 text-sm leading-relaxed mt-3">
                  Své texty staví na detailním výzkumu a praktické zkušenosti, díky čemuž pomáhá hráčům lépe se orientovat v prostředí online casin.
                </p>
              </div>

            </div>

            {/* ── Sticky sidebar ────────────────────────────── */}
            <aside className="lg:w-[300px] flex-shrink-0">
              <div className="lg:sticky lg:top-[84px] space-y-4">

                <div className="bg-white rounded-2xl border border-[#003da5]/25 shadow-[0_4px_24px_rgba(0,61,165,0.12)] p-5" data-testid="sidebar-cta">
                  <div className="flex items-center gap-3 mb-4">
                    <div className="w-12 h-12 rounded-lg bg-[#f3f6fb] flex items-center justify-center overflow-hidden">
                      <img src={logo16} alt="Wazamba" className="w-full h-full object-cover" />
                    </div>
                    <div>
                      <div className="font-bold text-gray-900 text-sm">Wazamba Casino</div>
                      <div className="flex items-center gap-0.5">
                        {[1,2,3,4].map(i => <Star key={i} className="w-3 h-3 fill-[#f5c518] text-[#f5c518]" />)}
                        <div className="relative w-3 h-3">
                          <Star className="w-3 h-3 text-[#f5c518]/30 absolute inset-0" />
                          <div className="overflow-hidden absolute inset-0" style={{ width: "50%" }}>
                            <Star className="w-3 h-3 fill-[#f5c518] text-[#f5c518]" />
                          </div>
                        </div>
                        <span className="text-gray-600 text-xs ml-1">9.0/10</span>
                      </div>
                    </div>
                  </div>
                  <div className="text-center mb-4 bg-[#f3f6fb] rounded-xl py-3">
                    <div className="text-gray-500 text-xs mb-0.5">Uvítací bonus (non-sticky)</div>
                    <div className="text-[#003da5] font-black text-xl">až 12 500 Kč</div>
                    <div className="text-[#c9960f] font-bold text-sm">+ 200 free spinů</div>
                    <div className="text-gray-400 text-xs mt-0.5">Wager 35× · Min. vklad 500 Kč</div>
                  </div>
                  <a href={CASINO_URL} target="_blank" rel="sponsored noopener noreferrer" className="block">
                    <Button
                      className="hraj-btn w-full font-bold gap-2"
                      data-testid="button-sidebar-cta"
                    >
                      Hraj <ArrowRight className="hraj-arrow w-4 h-4" />
                    </Button>
                  </a>
                  <p className="text-gray-400 text-xs text-center mt-2">18+ | Platí podmínky</p>
                </div>

                <div className="bg-white rounded-2xl border border-[#dde4ee] p-5">
                  <div className="font-bold text-gray-900 text-sm mb-3">Rychlý přehled</div>
                  <div className="space-y-2.5">
                    {([
                      { icon: Calendar,   label: "Rok",              value: "2019" },
                      { icon: Globe,      label: "Provozovatel",     value: "Rabidi N.V." },
                      { icon: Lock,       label: "Licence",          value: "Anjouan" },
                      { icon: Gamepad2,   label: "Celkem her",       value: "5 000+" },
                      { icon: Trophy,     label: "Automaty",         value: "2 000+" },
                      { icon: CreditCard, label: "Min. vklad",       value: "250 Kč (500 Kč pro bonus)" },
                      { icon: Zap,        label: "E-wallet výplaty", value: "0–24 hodin" },
                      { icon: Users,      label: "Sport bonus",      value: "100% až 2 500 Kč" },
                      { icon: Phone,      label: "Telefon",          value: "Ano" },
                    ] as const).map(({ icon: Icon, label, value }) => (
                      <div key={label} className="flex items-start gap-2">
                        <Icon className="w-4 h-4 text-[#003da5] mt-0.5 flex-shrink-0" />
                        <div className="min-w-0">
                          <span className="text-gray-400 text-xs">{label}: </span>
                          <span className="text-gray-800 font-medium text-xs">{value}</span>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>

                <div className="bg-amber-50 border border-amber-200 rounded-xl p-4">
                  <div className="font-bold text-amber-800 text-xs mb-1.5">Pozor u bonusu</div>
                  <p className="text-amber-700 text-xs leading-relaxed">
                    Vklady přes Neteller nebo Skrill se nepočítají pro uvítací bonus. Pro bonus volte jinou platební metodu.
                  </p>
                </div>

              </div>
            </aside>

          </div>
        </div>
      </main>
      
        <div className="max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-12 xl:px-16 pb-8">
          <DalsiRecenze currentSlug="wazamba" />
        </div>

  
        {/* Related reviews */}
        <div className="max-w-[900px] mx-auto px-4 py-4">
          <p className="text-sm text-gray-500 leading-relaxed text-center">
            <span className="font-semibold text-gray-700">Podobná kasina: </span>
              <a href="/kasina/alf-casino" className="text-[#003da5] hover:underline" data-testid="review-link-alf-casino">Alf Casino</a>
              {" · "}
              <a href="/kasina/casinia" className="text-[#003da5] hover:underline" data-testid="review-link-casinia">Casinia</a>
              {" · "}
              <a href="/kasina/spinit" className="text-[#003da5] hover:underline" data-testid="review-link-spinit">SPINiT</a>
            {" · "}
            <a href="/kasina" className="text-[#003da5] hover:underline font-semibold" data-testid="review-link-vsechna">Všechna kasina</a>
            {" · "}
            <a href="/porovnat" className="text-[#003da5] hover:underline" data-testid="review-link-porovnat">Porovnání</a>
          </p>
        </div>
      <Footer />
    </>
  );
}
